import React, { useState } from 'react';
import { Box, ListItemIcon, Menu, MenuItem, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Linkedin as LinkedInIcon, Share as ShareIcon } from '../../../../components/CustomIcon';
import { HeaderButton } from '../../../../components';
import useIsDocumentOwner from '../../../../helpers/hooks/useIsDocumentOwner';
import useLinkedInSharingLinks from '../../../../helpers/hooks/useLinkedInSharingLinks';

const LinkedInShareButton = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const isDocumentOwner = useIsDocumentOwner();
  const { addToProfileLink, createPostLink } = useLinkedInSharingLinks();
  const { t } = useTranslation();

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!isDocumentOwner) {
    return null;
  }

  return (
    <Box>
      <HeaderButton
        onClick={handleOpen}
        color="default"
        icon={<LinkedInIcon />}
        tooltip={t('linkedIn.share')}
      />
      <Menu
        // id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: -40,
          horizontal: 'left',
        }}
      >
        <MenuItem
          onClick={handleClose}
          component="a"
          href={addToProfileLink}
          target="_blank"
          rel="noopener noreferrer"
          divider={false}
        >
          <ListItemIcon>
            <ShareIcon />
          </ListItemIcon>
          <Typography color="textPrimary">{t('linkedIn.addCertToProfile')}</Typography>
        </MenuItem>
        <MenuItem
          onClick={handleClose}
          component="a"
          href={createPostLink}
          target="_blank"
          rel="noopener noreferrer"
          divider={false}
        >
          <ListItemIcon>
            <ShareIcon />
          </ListItemIcon>
          <Typography color="textPrimary">{t('linkedIn.createPost')}</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default LinkedInShareButton;
